import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensureMe } from '@/features/auth/useMe.ts';
import { PhoneScreen } from '@/features/auth/PhoneScreen.tsx';

export const Route = createFileRoute('/auth/phone')({
  validateSearch: (s: Record<string, unknown>): { redirect?: string } => (typeof s.redirect === 'string' ? { redirect: s.redirect } : {}),
  // already signed in (e.g. browser "back" after login) → straight into the app
  beforeLoad: async ({ search }) => {
    if (await ensureMe()) throw redirect({ to: search.redirect && search.redirect.startsWith('/') && !search.redirect.startsWith('/auth') ? search.redirect : '/', replace: true });
  },
  component: PhoneRoute,
});

function PhoneRoute() {
  const { redirect } = Route.useSearch();
  return <PhoneScreen redirect={redirect} />;
}
